import React from 'react';
import { ArrowRightIcon, CameraIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { Eyebrow } from './Eyebrow';
import { contact, images, urls } from '../data/site';
export function HeroSection() {
  return <section aria-labelledby="hero-heading" className="bg-ink text-paper" data-id="element-89" data-mp="23ww92xm2lupg">
      <div className="lg:grid lg:min-h-[620px] lg:grid-cols-[minmax(0,45fr)_minmax(0,55fr)] xl:min-h-[680px]" data-id="element-90" data-mp="28uxpfas43fx8">
        <div className="flex items-center px-5 pb-14 pt-12 sm:px-8 md:pb-20 md:pt-16 lg:py-20 lg:pl-[max(3rem,calc((100vw_-_1320px)/2_+_3rem))] lg:pr-12" data-id="element-91" data-mp="2wk8qyuhadecf">
          <div className="min-w-0 w-full max-w-[560px]" data-id="element-92" data-mp="2mufja4k9ljdg">
            <Eyebrow tone="dark" data-id="element-93" data-mp="2mrtak1ln0xtn">Commercial truck collision & body repair</Eyebrow>
            <h1 id="hero-heading" className="mt-6 font-display text-[46px] font-bold uppercase leading-[0.9] tracking-[-0.005em] sm:text-[64px] md:text-[80px] lg:text-[68px] xl:text-[90px] 2xl:text-[96px]" data-id="element-94" data-mp="2rrflg4dzu1za">
              <span className="block" data-id="element-95" data-mp="2ff8tcr2xo2ud">Get your{' '}</span>
              <span className="block" data-id="element-96" data-mp="2ffs5ts9tdz10">truck back{' '}</span>
              <span className="block" data-id="element-97" data-mp="2beq3v3oij8vc">
                to business<span className="text-brand" data-id="element-98" data-mp="2bc3tyxe5gh9y">.</span>
              </span>
            </h1>
            <p className="mt-7 max-w-[32rem] text-[17px] leading-relaxed text-steel-light md:text-lg" data-id="element-99" data-mp="2p7em4310eoam">
              Collision repair, bodywork and painting for semis, box trucks, fleets and trailers. Based in Brighton.
              Built for the vehicles you rely on.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-100" data-mp="2u3wqv2wcammy">
              <ButtonLink href={urls.quote} trailingIcon={ArrowRightIcon} className="w-full sm:w-auto" data-id="element-101" data-mp="382wce1ok2lew">
                Request a Repair Quote
              </ButtonLink>
              <ButtonLink href={contact.phoneHref} variant="outlineDark" leadingIcon={PhoneIcon} className="w-full sm:w-auto" data-id="element-102" data-mp="1dpmylxoz8dqu">
                Call {contact.phoneDisplay}
              </ButtonLink>
            </div>
            <p className="mt-6 flex items-start gap-2.5 text-sm text-steel-light" data-id="element-103" data-mp="3ds5yza0vcpg0">
              <CameraIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-bright" data-id="element-104" data-mp="3irindz7e24kp" />
              Have damage photos? Include them with your quote request.
            </p>
          </div>
        </div>

        <figure className="relative aspect-[4/3] w-full lg:aspect-auto lg:h-full" data-id="element-105" data-mp="3rsgw2usrv09m">
          <img src={images.hero} alt="Semi tractor with custom red, black and white paintwork parked in an asphalt cul-de-sac beside a grassy bank and trees" className="absolute inset-0 h-full w-full object-cover object-[50%_45%]" data-id="element-106" data-mp="lw5tdajjwdn" />
        </figure>
      </div>
    </section>;
}